var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-1"},_vm._l((_vm.posts),function(post,index){return _c('Post',{key:post.id,staticClass:"homepage-article",attrs:{"post":post,"index":index + _vm.layoutIndex}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }